// src/components/Signup.js
import React, { useState } from 'react';
import { auth,firestore } from '../../Config/firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore'; // Import Firestore methods
import "./styles.scss"

const Signup = ({switchLogin,closeTitleScreen}) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [error, setError] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    if(adminPassword==process.env.REACT_APP_ADMIN_PASSWORD){
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Save user details to Firestore
      await setDoc(doc(firestore, 'users', user.uid), {
        name: name,
        email: email,
      });

      console.log('User signed up and details saved!');
      closeTitleScreen()
    } catch (error) {
      setError(error.message);
    }
  }
  else{
    setError("Please enter correct admin password to create an account!");
  }
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        {/* <h2 className="signup-title">
          Create your account
        </h2> */}
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        <form className="signup-form" onSubmit={handleSignup}>
        <div className="form-group">
            {/* <label htmlFor="text" className="form-label">
              Full Name
            </label> */}
            <input
              id="name"
              type="text"
              placeholder='Full Name'
              required
              className="login-form-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-group">
            {/* <label htmlFor="email" className="form-label">
              Email address
            </label> */}
            <input
              id="email"
              type="email"
              placeholder='Email address'
              required
              className="login-form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            {/* <label htmlFor="password" className="form-label">
              Password
            </label> */}
            <input
              id="password"
              type="password"
              placeholder='Password'
              required
              className="login-form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            {/* <label htmlFor="password" className="form-label">
              Admin Password
            </label> */}
            <input
              id="password"
              type="password"
              placeholder='Admin Password'
              required
              className="login-form-input"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="login-button"
          >
            Sign up
          </button>
          <div className="signup-prompt">
            Already have an account? <button onClick={() => switchLogin("login")} className="link-button">Login</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Signup;